import Vue from 'vue'

export const busNotifications = new Vue({
	data() {
		return{
			notificationData: [],
			notificationSuccess: {
				type: "success",
				iconNotification: "check",
				classNotification: "alert-success",
				msg: this.msg
			},
			notificationWarning: {
				type: "success",
				iconNotification: "exclamation-circle",
				classNotification: "alert-warning",
				msg: "Mensage Advertencia"
			},
			notificationDanger: {
				type: "danger",
				iconNotification: "exclamation-triangle",
				classNotification: "alert-danger",
				msg: this.msg
			},
		}
	},
	methods:{
		makeNotification(status, mensaje){
			switch (status) {
				case 'warning':
					this.notificationData.unshift({
						type: status,
						icon: "exclamation-circle",
						class: "alert-warning",
						msg: mensaje,
					})
					break;
				case 'danger':
					this.notificationData.unshift({
						type: status,
						icon: "exclamation-triangle",
						class: "alert-danger",
						msg: mensaje,
					})
					break;
				case 'success':
					this.notificationData.unshift({
						type: status,
						icon: "check",
						class: "alert-success",
						msg: mensaje,
					})
					break;
			}
		},
		closeNotification(sentNotificationIndex){
			this.notificationData.splice(sentNotificationIndex, 1);
		}
	}
})



// WEBPACK FOOTER //
// ./src/bus.js